<template>
    <div class="app" id="wrapper">
        <scroll @refresh="refresh">
            <p class="top-tips" v-show="showMin"> 请尽快完成支付</p>
            <!--<p class="top-tips"> 请在<span class='f-strongest'> {{minutes}} 分 {{seconds}} 秒 </span>内完成支付，超时订单自动取消</p>-->
            <section class="doctor-info row" v-if="busiType != '5'">
                <div class="head pay-header"></div>
                <div class="info">
                    <p class="f-large pay-tips"><span class="f-strong">预约成功，请马上支付！</span>&nbsp;</p>
                    <p class="f-middle f-minor">订单号：{{orderId}}</p>
                    <p class="pay-type f-strongest f-largest">{{totalFee | formatFee}}</p>
                </div>
            </section>
            <section v-if="busiType === '5'">
                <dl class="field" style="height: 65px">
                    <span class="f-strong f-middle">订单号：{{ orderId }}</span>
                    <dd class="right-item f-strongest f-largest">{{ totalFee | formatFee }}</dd>
                </dl>
            </section>
            <section>
                <div class="panel">请选择支付方式</div>
                <ul class="list">
                    <li v-for="payType in payTypes" class="icon-row arr-item" @click="selectPayType(payType)">
                        <div class="col pay-icon"
                             :class="{ weixin: payType.id=='4', zhifubao: payType.id=='5', zizhu: payType.id=='8',union: payType.id == '7', social: payType.id == '10'}"></div>
                        <div class="desc col">
                            <div class="gwi-size-normal pay-title">{{ payType.name }}</div>
                            <div class="gwi-size-small">
                                <span v-if="payType.id=='4'" class="f-minor f-small"></span>
                                <span v-if="payType.id=='5'" class="f-minor f-small">需要安装支付宝APP客户端</span>
                                <span v-if="payType.id=='8'" class="f-minor f-small">自助机刷银行卡和社保卡</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </section>
        </scroll>
        <half-window v-model="showWindow" :data-list="voucherList">
            <span slot="title"><span class="f-strong">选择卡</span></span>
            <ul slot="list" class="list">
                <li v-for="item in voucherList" class="list-item" :class="'arr-item-blue'"
                    @click="selectPayCard(item)">
                    <span>{{item.holderName}}/{{item.bankCardNo  | dotted}}</span>
                </li>
            </ul>
        </half-window>
        <confirm text="该微信暂未绑定医保卡，请点击确定按钮绑卡！" v-model="showConfirm" @on-sure="goBindUrl"></confirm>
    </div>
</template>
<script>
    import payService from 'pay.service'
    import utils from 'utils'
    import queryVoucher from 'voucher.service'
    import HalfWindow from 'HalfWindow'
    import Confirm from 'Confirm'

    export default {
        components: {
            HalfWindow,
            Confirm
        },
        data() {
            return {
                payInfo: {},
                payType: {},
                payTypes: [],
                orderId: '',
                totalFee: '',
                outOrderId: 0,
                invokeType: 0,
                channelId: 0,
                busiType: '',
                params: {},
                seconds: '',
                minutes: '',
                openId: '',
                showMin: true,
                showWindow: false,
                voucherList: [],
                showConfirm: false,
                bindUrl: ''
            }
        },
        mounted() {
            this.refresh()
        },
        methods: {
            refresh() {
                var query = this.$router.currentRoute.query
                this.code = query.code

                const pay = this.$store.state.paramModule.param.pay
                this.payInfo = pay.payInfo
                this.orderId = pay.payInfo.orderId
                this.totalFee = pay.payInfo.fee
                this.busiType = pay.payInfo.busiType
                if (this.busiType === this.constant.BUSI_TYPE.OUT_PATIENT_PAYMENT || this.busiType === this.constant.BUSI_TYPE.IN_PATIENT_PAYMENT) {
                    this.showMin = false
                }
                this.cardNo = this.payInfo.cardNo
                this.cardType = this.payInfo.cardType
                // 加载支付渠道
                payService.getPayChannels({
                    busiType: this.busiType,
                }).then((res) => {
                    if (res.resultCode === this.constant.RESULT_SUCCESS) {
                        this.payTypes = res.data
                    } else {
                        this.$utils.alert(res.resultMsg)
                    }
                })
            },
            /* eslint-disable */
            selectPayType(payType) {
                this.channelId = payType.id
                // 从上级获取参数
                const params = {
                    clientIp:cnip() ,// returnCitySN["cip"],
                    orderId: this.orderId,
                    orderType: this.payInfo.orderType,
                    cardType: this.payInfo.cardType,
                    cardNo: this.payInfo.cardNo,
                    name: this.payInfo.name,
                    channelId: this.channelId,
                    // app 1; h5 2; o2o 3;
                    invokeType: this.constant.INVOKE_TYPE.WAP_INVOKE,
                    deviceId: this.code,
                }
                //判断是否为天府云渠道
                if (this.channelId === '4'&& (localStorage.channel === 'TFY' || localStorage.channel === 'TFTB' || localStorage.channel === 'TFRYB')) {
                    params.invokeType = this.constant.INVOKE_TYPE.H5_INVOKE
                }
                if (this.channelId === '7') {
                    // 银联支付
                    this.loadVouchers()
                } else if (this.channelId === '10') {
                    // 医保支付
                    if (localStorage.channel === 'TFY' || localStorage.channel === 'TFTB' || localStorage.channel === 'TFRYB') {
                        this.$utils.alert('医保支付只支持微信客户端');
                    } else {
                        params.invokeType = this.constant.INVOKE_TYPE.MEDICAL_INVOKE
                        this.getMedInfo(params)
                    }
                } else {
                    // 生成外部订单号
                    this.loadOutOrder(params)
                }
            },
            loadVouchers() {
                this.voucherList = []
                // 获取用户就诊凭证
                queryVoucher.getVoucherList().then((res) => {
                    if (res.resultCode !== this.constant.RESULT_SUCCESS) {
                        this.$utils.alert(res.resultMsg);
                        return;
                    }
                    this.voucherList = res.data ? res.data : [];
                    if (this.voucherList.length === 0) {
                        this.$utils.alert('请先绑定诊疗卡');
                        return
                    }
                    this.showWindow = true;
                });
            },
            getMedInfo(params) {
                this.$http.post('/app/pay/getMedInfo', params).then((res) => {
                    const result = res.data.data
                    if (res.data.resultCode === this.constant.RESULT_SUCCESS) {
                        if (res.data.data.cityId === '510100') {
                            params.extraMap = {
                                signNo: res.data.data.signNo,
                                name: params.name,
                                idCard: params.cardNo,
                                openId: res.data.data.openId
                            }
                            this.loadOutOrder(params)
                        } else {
                            this.$utils.alert('不支持非成都本地医保卡！')
                        }
                    } else {
                        if (res.data.data.errorCode === '80004') {
                            this.showConfirm = true;
                            this.bindUrl = res.data.data.bindUrl;
                        } else {
                            this.$utils.alert(res.data.data.errorMsg)
                        }
                    }
                })
            },
            goBindUrl() {
                window.location.href = this.bindUrl
            },
            loadOutOrder(params) {
                this.$http.post('/app/pay/order', params).then((res) => {
                    const result = res.data.data
                    if (res.data.resultCode === this.constant.RESULT_SUCCESS) {
                        this.requestOutOrderSuccess(result)
                    } else {
                        this.$utils.alert(res.data.resultMsg)
                    }
                })
            },
            requestOutOrderSuccess(res) {
                const payInfo = JSON.parse(res.payInfo);
                // 判断支付方式
                switch (this.channelId) {
                    case '4':
                        this.payWithWechat(res)
                        break
                    case '5':
                        // 支付宝支付
                        utils.alert('支付宝支付')
                        break
                    case '10':
                        // 医保支付
                        window.location.href = payInfo.payUrl
                        break
                    case '7':
                        // 银行卡支付
                        // utils.alert('银行卡支付')
                        this.$store.commit('updateParam', {
                            namespace: 'paySuccess',
                            unionPayInfo: payInfo.html,
                            paySuccessInfo: {
                                orderId: this.orderId,
                                fee: this.totalFee,
                                busiType: this.busiType,
                            },
                        })
                        this.$router.push('UnionPay')
                        break
                    case '8':
                        this.goSelfMachinePay(res)
                        break
                    default:
                        break
                }
            },
            goSelfMachinePay(res) {
                this.$store.commit('updateParam', {
                    namespace: 'order',
                    order: res,
                    totalFee: this.totalFee,
                })
                this.$router.push('SelfPay')
            },
            /* eslint-disable */
            payWithWechat(infos) {
                const that = this
                const payInfo = JSON.parse(infos.payInfo)

                //判断是否为天府云渠道
                if (localStorage.channel === 'TFY' || localStorage.channel === 'TFTB' || localStorage.channel === 'TFRYB') {
                    var mweb_url = payInfo.mweb_url
                    var orderId = that.orderId
                    var fee = that.totalFee
                    var busiType = that.busiType

                    //拼接UrlEncode处理后的后缀字段
                    mweb_url = `${mweb_url}%3forderId%3d${orderId}%26fee%3d${fee}%26busiType%3d${busiType}%26token%3d${localStorage.tokenId}`
                    window.location.href = mweb_url
                    return;
                }

                // 发起微信支付
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest',
                    {
                        appId: payInfo.appId,     // 公众号名称，由商户传入
                        timeStamp: payInfo.timeStamp, // 时间戳，自1970年以来的秒数
                        nonceStr: payInfo.nonceStr, // 随机串
                        package: payInfo.package,
                        signType: payInfo.signType, // 微信签名方式：
                        paySign: payInfo.sign, // 微信签名
                    },
                    function (res) {
                        // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
                        if (res.err_msg === 'get_brand_wcpay_request:ok') {
                            // 跳转支付成功或失败界面
                            that.$store.commit('updateParam', {
                                namespace: 'paySuccess',
                                paySuccessInfo: {
                                    orderId: that.orderId,
                                    fee: that.totalFee,
                                    busiType: that.busiType,
                                },
                            })
                            that.$router.replace('paySuccess')
                        }
                    })
            },
            selectPayCard: function (payCard) {
                const params = {
                    orderId: this.orderId,
                    orderType: this.payInfo.orderType,
                    cardType: this.payInfo.cardType,
                    cardNo: this.payInfo.cardNo,
                    channelId: this.channelId,
                    // app 1; h5 2; o2o 3;
                    invokeType: this.constant.INVOKE_TYPE.WAP_INVOKE,
                    deviceId: this.code,
                    accountNo: payCard.bankCardNo,
                }
                this.loadOutOrder(params)
            },
        },
    }
    function cnip() {
      //国内城市IP段
      var ips = '58.14.0.0,58.16.0.0,58.24.0.0,58.30.0.0,58.32.0.0,58.66.0.0,58.68.128.0,58.82.0.0,58.87.64.0,58.99.128.0,58.100.0.0,58.116.0.0,58.128.0.0,58.144.0.0,58.154.0.0,58.192.0.0,58.240.0.0,59.32.0.0,59.64.0.0,59.80.0.0,59.107.0.0,59.108.0.0,59.151.0.0,59.155.0.0,59.172.0.0,59.191.0.0,59.191.240.0,59.192.0.0,60.0.0.0,60.55.0.0,60.63.0.0,60.160.0.0,60.194.0.0,60.200.0.0,60.208.0.0,60.232.0.0,60.235.0.0,60.245.128.0,60.247.0.0,60.252.0.0,60.253.128.0,60.255.0.0,61.4.80.0,61.4.176.0,61.8.160.0,61.28.0.0,61.29.128.0,61.45.128.0,61.47.128.0,61.48.0.0,61.87.192.0,61.128.0.0,61.232.0.0,61.236.0.0,61.240.0.0,114.28.0.0,114.54.0.0,114.60.0.0,114.64.0.0,114.68.0.0,114.80.0.0,116.1.0.0,116.2.0.0,116.4.0.0,116.8.0.0,116.13.0.0,116.16.0.0,116.52.0.0,116.56.0.0,116.58.128.0,116.58.208.0,116.60.0.0,116.66.0.0,116.69.0.0,116.70.0.0,116.76.0.0,116.89.144.0,116.90.184.0,116.95.0.0,116.112.0.0,116.116.0.0,116.128.0.0,116.192.0.0,116.193.16.0,116.193.32.0,116.194.0.0,116.196.0.0,116.198.0.0,116.199.0.0,116.199.128.0,116.204.0.0,116.207.0.0,116.208.0.0,116.212.160.0,116.213.64.0,116.213.128.0,116.214.32.0,116.214.64.0,116.214.128.0,116.215.0.0,116.216.0.0,116.224.0.0,116.242.0.0,116.244.0.0,116.248.0.0,116.252.0.0,116.254.128.0,116.255.128.0,117.8.0.0,117.21.0.0,117.22.0.0,117.24.0.0,117.32.0.0,117.40.0.0,117.44.0.0,117.48.0.0,117.53.48.0,117.53.176.0,117.57.0.0,117.58.0.0,117.59.0.0,117.60.0.0,117.64.0.0,117.72.0.0,117.74.64.0,117.74.128.0,117.75.0.0,117.76.0.0,117.80.0.0,117.100.0.0,117.103.16.0,117.103.128.0,117.106.0.0,117.112.0.0,117.120.64.0,117.120.128.0,117.121.0.0,117.121.128.0,117.121.192.0,117.122.128.0,117.124.0.0,117.128.0.0,118.24.0.0,118.64.0.0,118.66.0.0,118.67.112.0,118.72.0.0,118.80.0.0,118.84.0.0,118.88.32.0,118.88.64.0,118.88.128.0,118.89.0.0,118.91.240.0,118.102.16.0,118.112.0.0,118.120.0.0,118.124.0.0,118.126.0.0,118.132.0.0,118.144.0.0,118.178.0.0,118.180.0.0,118.184.0.0,118.192.0.0,118.212.0.0,118.224.0.0,118.228.0.0,118.230.0.0,118.239.0.0,118.242.0.0,118.244.0.0,118.248.0.0,119.0.0.0,119.2.0.0,119.2.128.0,119.3.0.0,119.4.0.0,119.8.0.0,119.10.0.0,119.15.136.0,119.16.0.0,119.18.192.0,119.18.208.0,119.18.224.0,119.19.0.0,119.20.0.0,119.27.64.0,119.27.160.0,119.27.192.0,119.28.0.0,119.30.48.0,119.31.192.0,119.32.0.0,119.40.0.0,119.40.64.0,119.40.128.0,119.41.0.0,119.42.0.0,119.42.136.0,119.42.224.0,119.44.0.0,119.48.0.0,119.57.0.0,119.58.0.0,119.59.128.0,119.60.0.0,119.62.0.0,119.63.32.0,119.75.208.0,119.78.0.0,119.80.0.0,119.84.0.0,119.88.0.0,119.96.0.0,119.108.0.0,119.112.0.0,119.128.0.0,119.144.0.0,119.148.160.0,119.161.128.0,119.162.0.0,119.164.0.0,119.176.0.0,119.232.0.0,119.235.128.0,119.248.0.0,119.253.0.0,119.254.0.0,120.0.0.0,120.24.0.0,120.30.0.0,120.32.0.0,120.48.0.0,120.52.0.0,120.64.0.0,120.72.32.0,120.72.128.0,120.76.0.0,120.80.0.0,120.90.0.0,120.92.0.0,120.94.0.0,120.128.0.0,120.136.128.0,120.137.0.0,120.192.0.0,121.0.16.0,121.4.0.0,121.8.0.0,121.16.0.0,121.32.0.0,121.40.0.0,121.46.0.0,121.48.0.0,121.51.0.0,121.52.160.0,121.52.208.0,121.52.224.0,121.55.0.0,121.56.0.0,121.58.0.0,121.58.144.0,121.59.0.0,121.60.0.0,121.68.0.0,121.76.0.0,121.79.128.0,121.89.0.0,121.100.128.0,121.101.208.0,121.192.0.0,121.201.0.0,121.204.0.0,121.224.0.0,121.248.0.0,121.255.0.0,122.0.64.0,122.0.128.0,122.4.0.0,122.8.0.0,122.48.0.0,122.49.0.0,122.51.0.0,122.64.0.0,122.96.0.0,122.102.0.0,122.102.64.0,122.112.0.0,122.119.0.0,122.136.0.0,122.144.128.0,122.152.192.0,122.156.0.0,122.192.0.0,122.198.0.0,122.200.64.0,122.204.0.0,122.224.0.0,122.240.0.0,122.248.48.0,123.0.128.0,123.4.0.0,123.8.0.0,123.49.128.0,123.52.0.0,123.56.0.0,123.64.0.0,123.96.0.0,123.98.0.0,123.99.128.0,123.100.0.0,123.101.0.0,123.103.0.0,123.108.128.0,123.108.208.0,123.112.0.0,123.128.0.0,123.136.80.0,123.137.0.0,123.138.0.0,123.144.0.0,123.160.0.0,123.176.80.0,123.177.0.0,123.178.0.0,123.180.0.0,123.184.0.0,123.196.0.0,123.199.128.0,123.206.0.0,123.232.0.0,123.242.0.0,123.244.0.0,123.249.0.0,123.253.0.0,124.6.64.0,124.14.0.0,124.16.0.0,124.20.0.0,124.28.192.0,124.29.0.0,124.31.0.0,124.40.112.0,124.40.128.0,124.42.0.0,124.47.0.0,124.64.0.0,124.66.0.0,124.67.0.0,124.68.0.0,124.72.0.0,124.88.0.0,124.108.8.0,124.108.40.0,124.112.0.0,124.126.0.0,124.128.0.0,124.147.128.0,124.156.0.0,124.160.0.0,124.172.0.0,124.192.0.0,124.196.0.0,124.200.0.0,124.220.0.0,124.224.0.0,124.240.0.0,124.240.128.0,124.242.0.0,124.243.192.0,124.248.0.0,124.249.0.0,124.250.0.0,124.254.0.0,125.31.192.0,125.32.0.0,125.58.128.0,125.61.128.0,125.62.0.0,125.64.0.0,125.96.0.0,125.98.0.0,125.104.0.0,125.112.0.0,125.169.0.0,125.171.0.0,125.208.0.0,125.210.0.0,125.213.0.0,125.214.96.0,125.215.0.0,125.216.0.0,125.254.128.0,134.196.0.0,159.226.0.0,161.207.0.0,162.105.0.0,166.111.0.0,167.139.0.0,168.160.0.0,169.211.1.0,192.83.122.0,192.83.169.0,192.124.154.0,192.188.170.0,198.17.7.0,202.0.110.0,202.0.176.0,202.4.128.0,202.4.252.0,202.8.128.0,202.10.64.0,202.14.88.0,202.14.235.0,202.14.236.0,202.14.238.0,202.20.120.0,202.22.248.0,202.38.0.0,202.38.64.0,202.38.128.0,202.38.136.0,202.38.138.0,202.38.140.0,202.38.146.0,202.38.149.0,202.38.150.0,202.38.152.0,202.38.156.0,202.38.158.0,202.38.160.0,202.38.164.0,202.38.168.0,202.38.176.0,202.38.184.0,202.38.192.0,202.41.152.0,202.41.240.0,202.43.144.0,202.46.32.0,202.46.224.0,202.60.112.0,202.63.248.0,202.69.4.0,202.69.16.0,202.70.0.0,202.74.8.0,202.75.208.0,202.85.208.0,202.90.0.0,202.90.224.0,202.90.252.0,202.91.0.0,202.91.128.0,202.91.176.0,202.91.224.0,202.92.0.0,202.92.252.0,202.93.0.0,202.93.252.0,202.95.0.0,202.95.252.0,202.96.0.0,202.112.0.0,202.120.0.0,202.122.0.0,202.122.32.0,202.122.64.0,202.122.112.0,202.122.128.0,202.123.96.0,202.124.24.0,202.125.176.0,202.127.0.0,202.127.12.0,202.127.16.0,202.127.40.0,202.127.48.0,202.127.112.0,202.127.128.0,202.127.160.0,202.127.192.0,202.127.208.0,202.127.212.0,202.127.216.0,202.127.224.0,202.130.0.0,202.130.224.0,202.131.16.0,202.131.48.0,202.131.208.0,202.136.48.0,202.136.208.0,202.136.224.0,202.141.160.0,202.142.16.0,202.143.16.0,202.148.96.0,202.149.160.0,202.149.224.0,202.150.16.0,202.152.176.0,202.153.48.0,202.158.160.0,202.160.176.0,202.164.0.0,202.164.25.0,202.165.96.0,202.165.176.0,202.165.208.0,202.168.160.0,202.170.128.0,202.170.216.0,202.173.8.0,202.173.224.0,202.179.240.0,202.180.128.0,202.181.112.0,202.189.80.0,202.192.0.0,203.18.50.0,203.79.0.0,203.80.144.0,203.81.16.0,203.83.56.0,203.86.0.0,203.86.64.0,203.88.32.0,203.88.192.0,203.89.0.0,203.90.0.0,203.90.128.0,203.90.192.0,203.91.32.0,203.91.96.0,203.91.120.0,203.92.0.0,203.92.160.0,203.93.0.0,203.94.0.0,203.95.0.0,203.95.96.0,203.99.16.0,203.99.80.0,203.100.32.0,203.100.80.0,203.100.96.0,203.100.192.0,203.110.160.0,203.118.192.0,203.119.24.0,203.119.32.0,203.128.32.0,203.128.96.0,203.130.32.0,203.132.32.0,203.134.240.0,203.135.96.0,203.135.160.0,203.142.219.0,203.148.0.0,203.152.64.0,203.156.192.0,203.158.16.0,203.161.192.0,203.166.160.0,203.171.224.0,203.174.7.0,203.174.96.0,203.175.128.0,203.175.192.0,203.176.168.0,203.184.80.0,203.187.160.0,203.190.96.0,203.191.16.0,203.191.64.0,203.191.144.0,203.192.0.0,203.196.0.0,203.207.64.0,203.207.128.0,203.208.0.0,203.208.16.0,203.208.32.0,203.209.224.0,203.212.0.0,203.212.80.0,203.222.192.0,203.223.0.0,210.2.0.0,210.5.0.0,210.5.144.0,210.12.0.0,210.14.64.0,210.14.112.0,210.14.128.0,210.15.0.0,210.15.128.0,210.16.128.0,210.21.0.0,210.22.0.0,210.23.32.0,210.25.0.0,210.26.0.0,210.28.0.0,210.32.0.0,210.51.0.0,210.52.0.0,210.56.192.0,210.72.0.0,210.76.0.0,210.78.0.0,210.79.64.0,210.79.224.0,210.82.0.0,210.87.128.0,210.185.192.0,210.192.96.0,211.64.0.0,211.80.0.0,211.96.0.0,211.136.0.0,211.144.0.0,211.160.0.0,218.0.0.0,218.56.0.0,218.64.0.0,218.96.0.0,218.104.0.0,218.108.0.0,218.185.192.0,218.192.0.0,218.240.0.0,218.249.0.0,219.72.0.0,219.82.0.0,219.128.0.0,219.216.0.0,219.224.0.0,219.242.0.0,219.244.0.0,220.101.192.0,220.112.0.0,220.152.128.0,220.154.0.0,220.160.0.0,220.192.0.0,220.231.0.0,220.231.128.0,220.232.64.0,220.234.0.0,220.242.0.0,220.248.0.0,220.252.0.0,221.0.0.0,221.8.0.0,221.12.0.0,221.12.128.0,221.13.0.0,221.14.0.0,221.122.0.0,221.129.0.0,221.130.0.0,221.133.224.0,221.136.0.0,221.172.0.0,221.176.0.0,221.192.0.0,221.196.0.0,221.198.0.0,221.199.0.0,221.199.128.0,221.199.192.0,221.199.224.0,221.200.0.0,221.208.0.0,221.224.0.0,222.16.0.0,222.32.0.0,222.64.0.0,222.125.0.0,222.126.128.0,222.128.0.0,222.160.0.0,222.168.0.0,222.176.0.0,222.192.0.0,222.240.0.0,222.248.0.0';
      var arr = ips.split(',');
      var rnd = parseInt(Math.random() * ((arr.length - 1) - 0 + 1) + 0, 10)
      var ip = arr[rnd];
      return ip;
    }
    // 倒计时
    //    function countdown(that) {
    //        var waitTime = 60;
    //        var taskId = setInterval(() => {
    //            waitTime--;
    //            if (waitTime === -1) {
    //                if (that.minutes === 0) {
    //                    that.disabled = false;
    //                    clearInterval(taskId)
    //                    that.$router.back();
    //                    return;
    //                }
    //                that.minutes = that.minutes - 1;
    //                that.seconds = 59;
    //                waitTime = 59;
    //            }
    //            that.seconds = '' + waitTime + ''
    //        }, 1000)
    //    }

</script>
<style lang="scss">
    @import '../../../static/sass/_variable.scss';

    .pay-type {
        float: right;
        vertical-align: middle;
        margin-top: -31px;
        margin-right: 10px;
    }

    .pay-tips {
        margin-bottom: 5px;
    }
</style>



// WEBPACK FOOTER //
// Pay.vue?6c30065a